import React from 'react';

import { Header } from '@/widgets/Header';
import { PATHS } from '@/routes/paths';
import { WalletConnectWrapper } from '@/features/WalletConnect';
import { useToast } from '@/shared/hooks/useToast';

const contentList = [
    {
        text: 'Pools',
        value: PATHS.HOME,
        children: [PATHS.BORROW],
    },
    {
        text: 'Vaults',
        value: PATHS.VAULTS,
        children: [PATHS.VAULTS_MANAGE],
    },
    {
        text: 'Order Book',
        value: PATHS.ORDER_BOOK,
        children: [PATHS.ORDER_BOOK_BORROW],
    },
];

export const AppHeader = () => {
    const { toast } = useToast();

    const handleSetBannerState = (value: boolean) => {
        if (value) {
            toast({
                title: 'Arkis is not supported on this network.',
                description: 'Please switch to Ethereum',
                variant: 'error',
            });
        }
    };

    return (
        <>
            <Header
                contentList={contentList}
                rightSide={
                    <>
                        <WalletConnectWrapper handleSetBannerState={handleSetBannerState} />
                    </>
                }
            />
        </>
    );
};
